// import { confirmationEmailPage } from './confirmationEmailPage'
// import { ConfirmationEmail } from '../components/ConfirmationEmail'
import { PrintFOIA } from '../components/PrintFOIA'
import { Submit } from '../components/Submit'

export const reviewPage = complaintInspect => {
  // const confirmEmailPage = confirmationEmailPage()
  const page = {
    id: 'review_page',
    fields: [
      {
        type: 'content',
        content: PrintFOIA
      },
      {
        type: 'content',
        content: complaintInspect
      }
      // {
      //   type: 'content',
      //   content: ConfirmationEmail
      // }
    ]
    // validation: confirmEmailPage.validation
  }

  // page.fields.push(...confirmEmailPage.fields)
  page.fields.push({
    type: 'content',
    content: Submit
  })

  return page
}
